import { useContext, useMemo } from "react"
import currency from "currency.js"
import { formatMoney } from "@bussola-viagens/utils"
import { AuthContext } from "./contexts"
import { useAPI } from "./hooks"

const EN: { [k: string]: string } = {
    "Passageiros": "Passengers",
    "Milhas": "Miles",
    "Moeda": "Currency",
    "Custo:": "Cost:",
    "Margem:": "Margin:",
    "Rentabilidade:": "Profitability:",
    "Total:": "Total:",
    "Observações:": "Notes:",
    "Observações": "Notes",
    "Gerar Orçamento": "Generate Quote",
    "O voo é dentro dos próximos 7 dias?": "Is the flight within the next 7 days?",
    "Utilize este campo para custos extras como bagagens e marcação de assentos.": "Use this field for extra costs such as baggage and seat selection.",
    "Bem-vindo(a) à Bússola,": "Welcome to Bussola,",
    "Home": "Home",
    "Orçamentos": "Quotes",
    "Meus Orçamentos": "My Quotes",
    "Documentos": "Documents",
    "Treinamentos": "Trainings",
    "Meus Treinamentos": "My Trainings",
    "Banco de Mídias": "Media Library",
    "Bancos de Mídias": "Media Library",
    "Promoções": "Promotions",
    "Minhas Promoções": "My Promotions",
    "Pedidos": "Orders",
    "Meu Perfil": "My Profile",
    "Usuários": "Users",
    "Grupos": "Groups",
    "Custos": "Costs",
    "Sair": "Log out",
    "Logout": "Log out"
}

export const groupCurrency = (me: any): string => {
    const cfg = (me && me.group && (me.group as any).configuration) || {}
    for (const key of Object.keys(cfg)) {
        const c: any = (cfg as any)[key]
        if (c && typeof c === "object" && c.currency && c.currency !== "BRL") return c.currency
    }
    return "BRL"
}

export const useT = () => {
    const { me } = useContext(AuthContext)
    const foreign = groupCurrency(me) !== "BRL"
    return useMemo(() => (s: string) => (foreign && EN[s]) ? EN[s] : s, [foreign])
}

export const useProfileDisplay = (configuration?: { currency?: string, exchange_markup?: string | number }) => {
    const { me } = useContext(AuthContext)
    const cur = (configuration && configuration.currency) || groupCurrency(me)
    const markup = Number((configuration && configuration.exchange_markup) ?? 7)
    const [rates] = useAPI(`/currency`)
    const brlToCur = cur === "BRL" ? 1 : Number(rates.data?.rates?.[cur] || 0)
    const foreign = cur !== "BRL" && brlToCur > 0
    const intl = new Intl.NumberFormat("en-US", { style: "currency", currency: cur === "BRL" ? "USD" : cur })
    const fmt = (v: number) => foreign ? intl.format(currency(v, { precision: 4 }).multiply(brlToCur).value) : formatMoney(v)
    const fmtTyped = (v: number) => foreign ? intl.format(v) : formatMoney(v)
    const toBRL = (v: number, withMarkup?: boolean) => foreign ? currency(v, { precision: 4 }).divide(brlToCur).multiply(withMarkup ? 1 + markup / 100 : 1).value : v
    return { cur, markup, foreign, fmt, fmtTyped, toBRL }
}
